module.exports = __webpack_public_path__ + "images/emoji/carousel_horse.17c921f5e0d61f846707.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/carousel_horse.png
// module id = s/Gg
// module chunks = 2